import { Fragment } from "react";

function DataTableHeader({
  title,
  description,
  rightElement,
  headerMiddleElement,
}) {
  return (
    <Fragment>
      <div
        className={`standard-data-table-header ${
          headerMiddleElement ? "has-middle-element" : ""
        }`}
      >
        <div className="standard-data-table-header-left">
          <h3 className="standard-data-table-header-title">{title}</h3>
          <p>{description}</p>
        </div>

        <div className="standard-data-table-header-right">
          {headerMiddleElement && headerMiddleElement}
          {rightElement}
        </div>
      </div>
    </Fragment>
  );
}

export default DataTableHeader;
